import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type IdentificationFullInfo = components['schemas']['FullInfo'];

type FetchIdentificationInfoOperation = paths['/executor_web/identification/info']['get'];

export type FetchIdentificationInfoResponse =
	FetchIdentificationInfoOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/identification/info` — см. `paths['/executor_web/identification/info']` в auth swagger */
export function fetchIdentificationInfo(signal?: AbortSignal) {
	return axiosInstance.get<FetchIdentificationInfoResponse>('identification/info', {signal});
}
